import { useMutationGenerateContentUploadInfo } from 'graphQL/Image/useMutationGenerateContentUploadInfo';
import { useEffect, useRef, useState } from 'react';
// import ReactQuill from 'react-quill';
import ReactQuill from 'react-quill-new';
import {
  callWebviewHandler,
  isWebview,
  WebviewOperatorType,
} from 'utils/webview';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const useIntroduceModifyHooks = (editorValue: string) => {
  const { handleGenerateContentUpload } =
    useMutationGenerateContentUploadInfo();

  const containerRef = useRef<HTMLDivElement>(null);
  // const quillRef = useRef<ReactQuill>(null);
  const quillRef = useRef<any>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState<string>(editorValue);
  const [imageLoading, setImageLoading] = useState<boolean>(false);

  const isAbled = value !== editorValue;

  const handleImageUploadClick = () => {
    if (fileInputRef.current) {
      if (isWebview()) {
        callWebviewHandler(
          WebviewOperatorType.UpdateMessageImageFileHandler,
          undefined,
          'handleImageUpload',
        );
      } else {
        fileInputRef.current.click();
      }
    }
  };

  const handleImageUpload = (link: { link: string }) => {
    const result = JSON.parse(link.link);

    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      const range = editor.getSelection();

      if (link.link) {
        setImageLoading(false);
        editor.insertEmbed(range ? range.index : 0, 'image', result.url);
      }
    }
  };

  const handleWebImageUpload = (link: { link: string }) => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      const range = editor.getSelection();

      if (link.link) {
        editor.insertEmbed(range ? range.index : 0, 'image', link.link);
      }
    }
  };

  const handleImageDrop = (file: File) => {
    if (file.size > MAX_FILE_SIZE) {
      window.showToast(
        '파일 크기가 너무 큽니다. 10MB 이하로 업로드해 주세요',
        'failed',
      );

      return;
    }

    setImageLoading(true);

    handleGenerateContentUpload(
      {
        file: file,
        fileName: file.name,
      },
      (url: string, contentId: string) => {
        handleWebImageUpload({ link: url });

        setImageLoading(false);
      },
    );
  };

  const handleFileChange = (event: any) => {
    if (event.target.files[0].size > MAX_FILE_SIZE) {
      window.showToast(
        '파일 크기가 너무 큽니다. 10MB 이하로 업로드해 주세요',
        'failed',
      );

      return;
    }

    setImageLoading(true);

    handleGenerateContentUpload(
      {
        file: event.target.files[0],
        fileName: event.target.files[0].name,
      },
      (url: string, contentId: string) => {
        handleWebImageUpload({ link: url });

        setImageLoading(false);
      },
    );
  };

  const handleResetIntroduce = () => {
    setValue(editorValue);
  };

  useEffect(() => {
    window.handleImageUpload = handleImageUpload;
    window.handleImageLoading = () => {
      setImageLoading(true);
    };
  }, []);

  return {
    containerRef,
    quillRef,
    fileInputRef,
    value,
    isAbled,
    imageLoading,
    setValue,
    handleImageUploadClick,
    handleFileChange,
    handleImageDrop,
    handleImageUpload,
    handleResetIntroduce,
  };
};
